"use client";

import styled, { keyframes } from "styled-components";

//Components
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import Image from "../image";
import Button from "../button";

const ping = keyframes`
75%, 100% {
    transform: scale(2);
    opacity: 0;
}
`;

export const BoxNotfication = styled(DropdownMenu)``;

export const ButtonNotfication = styled(DropdownMenuTrigger)`
  position: relative;
  padding: 8px;
  cursor: pointer;

  svg {
    path {
      transition: all 0.3s easy-out;
      fill: var(--colorTitle);
    }
  }
`;

export const AlertNotification = styled.div`
  position: absolute;
  top: 1px;
  right: 5px;
  display: flex;
  height: 10px;
  width: 10px;
`;

export const Ping = styled.span`
  position: absolute;
  display: inline-flex;
  height: 100%;
  width: 100%;
  border-radius: 99999px;
  background-color: #f87171;
  opacity: 0.75;
  animation: ${ping} 1s cubic-bezier(0, 0, 0.2, 1) infinite;
`;

export const Dot = styled.span`
  position: realtive;
  display: inline-flex;
  height: 10px;
  width: 10px;
  border-radius: 9999px;
  background: #ef4444;
`;

export const NotficationContent = styled(DropdownMenuContent)`
  max-width: 320px;
  width: 100%;
  top: 5px !important;
  background: var(--backgroundColorCard);
`;

export const ButtonItemNotfication = styled.a`
  display: flex;
  align-item: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
`;

export const ImageUserNotfication = styled(Image)`
  width: 48px;
  height: 48px;
  border-radius: 5px;
`;

export const ContentNotfication = styled.div`
  width: calc(100% - 58px);
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TitleNotfication = styled.h1`
  font-family: "Helvetica Neue";
  font-weight: 600;
  font-size: 0.8rem;
  color: var(--colorTitle);
  margin-bottom: 0;
`;

export const DescriptionNotfication = styled.p`
  font-family: "Roboto Light";
  font-weight: 400;
  font-size: 0.7rem;
  width: 270px;
  max-width: 100%;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--textLight);
`;

export const DateNotfication = styled.span`
  font-family: "Roboto Light";
  font-weight: 400;
  font-size: 0.6rem;
  color: var(--textLight);
`;

export const BoxButton = styled.div`
  padding: 10px 8px;
`;

export const ButtonComponent = styled(Button)``;
